import { DeepKeyof, language } from "../../../traductions";

const traduction = {
  it: {
    prevNextCS: {
      title: "Scopri altri progetti",
      prev: "Prev",
      next: "Next",
    },
  },
  en: {
    prevNextCS: {
      title: "Discover other projects",
      prev: "Prev",
      next: "Next",
    },
  },
};

export const l_prevNextCS = (
  trad: DeepKeyof<typeof traduction[keyof typeof traduction]>
) => {
  const tokens = trad.split(".");
  let resource = traduction && (traduction as any)[language.code];
  if (!resource) {
    return tokens[tokens.length - 1];
  }

  for (let c = 0; c < tokens.length; c++) {
    resource = resource[tokens[c]];
    if (!resource) {
      // resource not found
      return trad;
    }
  }

  return resource;
};
